export const getWatchlist = async (id, list) => {
    try {
        const res = await fetch(`/api/watchlist/get-watchlist?userId=${id}&list=${list}`);
        const response = await res.json();
        return response.list
    } catch (error) {
        console.error(error);
    }
}